"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _programNameCardUpdater["default"];
  }
});
var _programNameCardUpdater = _interopRequireDefault(require("./programNameCardUpdater"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }